import React from "react";
import moment from "moment";
import Select from "react-select";

import NumberFormat from "react-number-format";
import { Tabs, Tab, Button, ButtonGroup } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";

import { AutoSizer, Grid } from "react-virtualized";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faGripHorizontal } from "@fortawesome/free-solid-svg-icons";

import TableLoader, {
  Table,
  TableBody,
  TableColumn,
  TableRow,
  TableHeaderRow,
  TableHeaderColumn
} from "components/Table/Table.js";
import SearchInput from "components/Inputs/SearchInput/SearchInput";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { getTileDimensions } from "components/Home/Utils/Utils";

import styles from "./style.module.css";

export default class SubView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0, fixMe: false };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  renderShowMore(style) {
    const { fetchNext, fetchAll, isLoading, length, hideShowMore } = this.props;

    if (hideShowMore) {
      return <React.Fragment></React.Fragment>;
    }

    return (
      <div style={style} key={"showMore"}>
        {!isLoading && fetchNext && (
          <div className={styles.showHolder}>
            <a className={styles.showMore} onClick={() => fetchNext()}>
              {"Show More"}
            </a>
            {fetchAll && (
              <a className={styles.showMore} style={{ marginLeft: "20px" }} onClick={() => fetchAll()}>
                {"Show All"}
              </a>
            )}
          </div>
        )}
        {isLoading && (
          <div className={styles.lHolder}>
            <LoadingIndicator />
          </div>
        )}
      </div>
    );
  }

  renderShowWhenEmpty() {
    const { fetchNext, fetchAll, isLoading, length, whenEmpty } = this.props;

    if (!whenEmpty || isLoading) {
      return <React.Fragment key={"showWhenEmpty"} />;
    }

    return <div className={styles.whenEmptyHolder}>{whenEmpty}</div>;
  }

  renderTiles() {
    const {
      children,
      firstTile,
      fetchNext,
      fetchAll,
      isLoading,
      type,
      firstWidth,
      isInfinite,
      renderTile,
      childrenLength,
      height,
      width,
      length,
      tileHeight,
      hideShowMore,
      isModal,
      isMini,
      emptyMessage
    } = this.props;
    const tileDimensions = {
      wrapperWidth: 240,
      wrapperHeight: 250
    };
    let gridColWidth = tileDimensions.wrapperWidth;
    let gridHeight = tileDimensions.wrapperHeight + 15;
    let gridRowHeight = tileDimensions.wrapperHeight;

    if (this.state.width < 800) {
      gridColWidth = 140;
      gridHeight = 145;
      gridRowHeight = 130;
    }
    if (tileHeight) {
      gridHeight = tileHeight + 20;
      gridRowHeight = tileHeight;
    }
    if (height) {
      gridHeight = height + 20;
      gridRowHeight = height;
    }
    if (width) {
      gridColWidth = width;
    }
    const firstTileChildren =
      firstTile &&
      firstTile.props &&
      firstTile.props.children &&
      firstTile.props.children.length > 1 &&
      firstTile.props.children.filter((e) => Boolean(e));
    const firstTileLength = firstTileChildren ? firstTileChildren.length : 0;
    return type === "all" || isMini ? (
      <div className={styles.listHolder} style={{ marginTop: "5px" }}>
        <div className={styles.flexHold}>
          {isMini !== true && (
            <div
              className={styles.fList}
              style={
                firstWidth
                  ? {
                      width: firstWidth,
                      minWidth: firstWidth
                    }
                  : {}
              }
            >
              {firstTile}
            </div>
          )}
          <div className={styles.list} style={isInfinite ? { overflow: "visible" } : {}}>
            {!isLoading && length === 0 && !firstTileLength && (
              <div
                className={styles.lHolder}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "10px"
                }}
              >
                {"No results found"}
                {this.renderShowMore()}
              </div>
            )}
            {(length !== 0 || firstTileLength || isLoading) && isInfinite && (
              <AutoSizer>
                {({ height, width }) => (
                  <Grid
                    cellRenderer={({ columnIndex, style }) =>
                      isMini ? (
                        columnIndex < firstTileLength ? (
                          columnIndex === 0 ? (
                            <div className={styles.firstTileHolder} key={"firstTile"}>
                              {firstTile}
                            </div>
                          ) : (
                            <React.Fragment key={"null-" + columnIndex} />
                          )
                        ) : columnIndex - firstTileLength >= childrenLength ? (
                          this.renderShowMore(style)
                        ) : (
                          renderTile(columnIndex - firstTileLength, style)
                        )
                      ) : columnIndex >= childrenLength ? (
                        this.renderShowMore(style)
                      ) : (
                        renderTile(columnIndex, style)
                      )
                    }
                    columnCount={childrenLength + 1 + (isMini ? firstTileLength : 0)}
                    columnWidth={gridColWidth}
                    height={gridHeight}
                    rowCount={1}
                    rowHeight={gridRowHeight}
                    overscanColumnCount={5}
                    width={width}
                    style={{ outline: "none" }}
                    key={this.state.width}
                  />
                )}
              </AutoSizer>
            )}
            {!isInfinite && children}
            {!isInfinite && this.renderShowMore()}
            {!isLoading && !childrenLength && this.renderShowWhenEmpty()}
          </div>
        </div>
      </div>
    ) : (
      <div className={styles.tileHolder} style={height ? { height: height, overflow: "auto" } : {}}>
        <div className={styles.tileH + (isModal ? " " + styles.modal : "")}>
          {firstTile}
          {!isLoading && length === 0 ? (
            emptyMessage ? (
              emptyMessage
            ) : (
              <div>
                <div
                  className={styles.lHolder}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "10px"
                  }}
                >
                  {"No results found"}
                </div>
              </div>
            )
          ) : (
            ""
          )}
          {isInfinite &&
            childrenLength > 0 &&
            Array(childrenLength)
              .fill()
              .map((_, i) => renderTile(i))}
        </div>
        {isLoading && (
          <div className={styles.lHolder}>
            <LoadingIndicator style={{ marginTop: "-60px" }} />
          </div>
        )}
        {!isLoading && fetchNext && !hideShowMore && (
          <div className={styles.showHolder} style={{ height: "20px", marginTop: "20px" }}>
            <a className={styles.showMore} onClick={() => fetchNext()}>
              {"Show More"}
            </a>
          </div>
        )}
        {!isLoading && !childrenLength && this.renderShowWhenEmpty()}
      </div>
    );
  }

  renderTable() {
    const { label, headers, children, firstRow, fetchNext, isLoading, renderTile, childrenLength, length, type } =
      this.props;
    return (
      <div>
        <div className={styles.typeHeader}>
          {label}
          <div className={styles.tableActions}>
            {firstRow}
            {length > 0 && !isLoading && (
              <div className={styles.showMore} style={{ marginLeft: "20px", textAlign: "center" }}>
                <a onClick={() => fetchNext(type)}>{"Show More"}</a>
              </div>
            )}
            {isLoading && <LoadingIndicator style={{ margin: "0px", position: "absolute", right: "-80px" }} />}
          </div>
        </div>
        <div className={styles.homeTableHolder} style={{ maxHeight: type === "all" ? "25vh" : "calc(100vh - 404px)" }}>
          {headers && length > 0 && (
            <Table className="table">
              <TableHeaderRow>
                {headers.map((h, i) => (
                  <TableHeaderColumn key={i}>{h}</TableHeaderColumn>
                ))}
              </TableHeaderRow>
              <TableBody>
                {Array(childrenLength)
                  .fill()
                  .map((_, i) => renderTile(i))}
              </TableBody>
            </Table>
          )}
          {!childrenLength && this.renderShowWhenEmpty()}
          {!isLoading && length === 0 && <div className={styles.emptyJobs}>{"No results found"}</div>}
        </div>
      </div>
    );
  }

  render() {
    const { isTile, height } = this.props;

    return (
      <div className={styles.subView} style={height ? { height: height + "px" } : {}}>
        {isTile ? this.renderTiles() : this.renderTable()}
      </div>
    );
  }
}
